import _extends from "@babel/runtime/helpers/esm/extends";
import { createElement } from "@wordpress/element";

/**
 * External dependencies
 */
import { contextConnect } from '@wp-g2/context';
import { identity } from 'lodash';
/**
 * Internal dependencies
 */

import { View } from '../view';
/* eslint-disable jsdoc/require-returns-description */

/**
 * @template {import('reakit-utils/types').As} T
 * @template {import('@wp-g2/create-styles').ViewOwnProps<{}, T>} P
 * @param {import('./types').Options<T, P>} options
 * @return {import('@wp-g2/create-styles').PolymorphicComponent<T, import('@wp-g2/create-styles').PropsFromViewOwnProps<P>>}
 */

/* eslint-enable jsdoc/require-returns-description */

/* eslint-disable jsdoc/no-undefined-types */

export var createComponent = function createComponent(_ref) {
  var as = _ref.as,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? 'Component' : _ref$name,
      _ref$useHook = _ref.useHook,
      useHook = _ref$useHook === void 0 ? identity : _ref$useHook,
      _ref$memo = _ref.memo,
      memo = _ref$memo === void 0 ? true : _ref$memo;

  /**
   * @param {P} props
   * @param {import('react').Ref<T>} forwardedRef
   */
  function Component(props, forwardedRef) {
    var otherProps = useHook(props);
    return createElement(View, _extends({
      as: as || 'div'
    }, otherProps, {
      ref: forwardedRef
    }));
  }

  Component.displayName = name; // @ts-ignore

  return contextConnect(Component, name, {
    memo: memo
  });
};
/* eslint-enable jsdoc/no-undefined-types */
//# sourceMappingURL=create-component.js.map